import styled from 'styled-components';
import BottomModal from '../../../components/modal/BottomModal';
import { Fragment, useEffect, useState } from 'react';

interface Props {
  activeTab: string;
  setActiveTab: (t: string) => void;
  court: string;
  setCourt: (court: string) => void;
  regionCode: string;
  setRegionCode: (code: string) => void;
  regionList: { current_ctp_cd: string; ctp_kor_nm_abbr: string }[];
  onClose: () => void;
}
// 법원 리스트
const courthouseListStatic = [
  {
    region: '서울',
    courts: [
      '서울중앙지방법원 본원',
      '서울동부지방법원 본원',
      '서울서부지방법원 본원',
      '서울남부지방법원 본원',
      '서울북부지방법원 본원',
    ],
  },
  {
    region: '의정부',
    courts: [
      '의정부지방법원 본원',
      '의정부지방법원 고양지원',
      '의정부지방법원 남양주지원',
    ],
  },
  {
    region: '수원',
    courts: [
      '수원지방법원 본원',
      '수원지방법원 성남지원',
      '수원지방법원 여주지원',
      '수원지방법원 평택지원',
      '수원지방법원 안산지원',
      '수원지방법원 안양지원',
    ],
  },
  {
    region: '인천',
    courts: ['인천지방법원 본원', '인천지방법원 부천지원'],
  },
  {
    region: '부산',
    courts: [
      '부산지방법원 본원',
      '부산지방법원 동부지원',
      '부산지방법원 서부지원',
    ],
  },

  {
    region: '청주',
    courts: [
      '청주지방법원 본원',
      '청주지방법원 충주지원',
      '청주지방법원 제천지원',
      '청주지방법원 영동지원',
    ],
  },

  {
    region: '대전',
    courts: [
      '대전지방법원 본원',
      '대전지방법원 홍성지원',
      '대전지방법원 논산지원',
      '대전지방법원 천안지원',
      '대전지방법원 공주지원',
      '대전지방법원 서산지원',
    ],
  },

  {
    region: '울산',
    courts: ['울산지방법원 본원'],
  },

  {
    region: '창원',
    courts: [
      '창원지방법원 본원',
      '창원지방법원 마산지원',
      '창원지방법원 진주지원',
      '창원지방법원 통영지원',
      '창원지방법원 밀양지원',
      '창원지방법원 거창지원',
    ],
  },

  {
    region: '대구',
    courts: [
      '대구지방법원 본원',
      '대구지방법원 서부지원',
      '대구지방법원 안동지원',
      '대구지방법원 경주지원',
      '대구지방법원 김천지원',
      '대구지방법원 상주지원',
      '대구지방법원 의성지원',
      '대구지방법원 영덕지원',
      '대구지방법원 포항지원',
    ],
  },

  {
    region: '광주',
    courts: [
      '광주지방법원 본원',
      '광주지방법원 목포지원',
      '광주지방법원 장흥지원',
      '광주지방법원 순천지원',
      '광주지방법원 해남지원',
    ],
  },

  {
    region: '전주',
    courts: [
      '전주지방법원 본원',
      '전주지방법원 군산지원',
      '전주지방법원 정읍지원',
      '전주지방법원 남원지원',
    ],
  },

  {
    region: '춘천',
    courts: [
      '춘천지방법원 본원',
      '춘천지방법원 강릉지원',
      '춘천지방법원 원주지원',
      '춘천지방법원 속초지원',
      '춘천지방법원 영월지원',
    ],
  },

  {
    region: '제주',
    courts: ['제주지방법원 본원'],
  },
];
const TabList = ['지역', '법원'];

function RegionModal({
  activeTab,
  setActiveTab,
  court,
  setCourt,
  regionCode,
  setRegionCode,
  regionList,
  onClose,
}: Props) {
  const [localActiveTab, setLocalActiveTab] = useState(activeTab);
  const [localRegion, setLocalRegion] = useState(regionCode);
  const [localCourt, setLocalCourt] = useState(court);
  const [openRegionList, setOpenRegionList] = useState<string[]>([]);

  const resetLocalState = () => {
    setLocalActiveTab(activeTab);
    setLocalRegion(regionCode);
    setLocalCourt(court);
    setOpenRegionList([]);
  };

  useEffect(() => {
    setLocalActiveTab(activeTab);
  }, [activeTab]);

  useEffect(() => {
    setLocalRegion(regionCode);
  }, [regionCode]);

  useEffect(() => {
    setLocalCourt(court);
  }, [court]);

  const handleConfirm = () => {
    setActiveTab(localActiveTab);
    setCourt(localCourt);
    setRegionCode(localRegion);
    onClose();
  };

  const handleCancel = () => {
    resetLocalState();
    onClose();
  };

  const toggleRegion = (r: string) => {
    if (openRegionList.includes(r)) {
      setOpenRegionList(openRegionList.filter((i) => i !== r));
    } else {
      setOpenRegionList([...openRegionList, r]);
    }
  };

  const toggleTab = (t: string) => {
    setLocalRegion('');
    setOpenRegionList([]);
    setLocalCourt('');
    setLocalActiveTab(t);
  };

  return (
    <BottomModal onClose={handleCancel}>
      <Header>지역/법원 선택</Header>
      <TabContainer>
        {TabList.map((item) => (
          <Tab
            key={item}
            $active={item === localActiveTab}
            onClick={() => toggleTab(item)}
          >
            {item}
          </Tab>
        ))}
      </TabContainer>
      <Content>
        {localActiveTab === '지역' ? (
          [{ current_ctp_cd: '', ctp_kor_nm_abbr: '전체' }, ...regionList].map(
            (region) => (
              <Item
                key={region.current_ctp_cd}
                onClick={() => setLocalRegion(region.current_ctp_cd)}
              >
                <ItemLabel $active={localRegion === region.current_ctp_cd}>
                  {region.ctp_kor_nm_abbr}
                </ItemLabel>
                {localRegion === region.current_ctp_cd && (
                  <div
                    style={{
                      width: '40px',
                      height: '40px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <img
                      src="/assets/images/check/npl-blue-check.svg"
                      alt="active"
                    />
                  </div>
                )}
              </Item>
            ),
          )
        ) : (
          <>
            <Item onClick={() => setLocalCourt('')}>
              <ItemLabel $active={localCourt === ''}>전체</ItemLabel>
              {localCourt === '' && (
                <div
                  style={{
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <img
                    src="/assets/images/check/npl-blue-check.svg"
                    alt="active"
                  />
                </div>
              )}
            </Item>
            {courthouseListStatic.map(({ region, courts }) => (
              <Fragment key={region}>
                <DropdownRegion onClick={() => toggleRegion(region)}>
                  <DropdownRegionLabel>{region}</DropdownRegionLabel>
                  <DropdownArrow
                    src="/assets/images/arrow/arrow-right-tertiary.svg"
                    alt=""
                    $open={openRegionList.includes(region)}
                  />
                </DropdownRegion>
                {openRegionList.includes(region) &&
                  courts.map((c) => (
                    <Item key={c} onClick={() => setLocalCourt(c)}>
                      <ItemLabel $active={localCourt === c}>{c}</ItemLabel>
                      {localCourt === c && (
                        <div
                          style={{
                            width: '40px',
                            height: '40px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/check/npl-blue-check.svg"
                            alt="active"
                          />
                        </div>
                      )}
                    </Item>
                  ))}
              </Fragment>
            ))}
          </>
        )}
      </Content>
      <Bottom>
        <CancleButton onClick={handleCancel}>취소</CancleButton>
        <ConfirmButton onClick={handleConfirm}>적용</ConfirmButton>
      </Bottom>
    </BottomModal>
  );
}

export default RegionModal;

const Header = styled.div`
  display: flex;
  padding: 24px 20px 8px 20px;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;

  color: #0c0e12;
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: -0.36px;
`;

const TabContainer = styled.div`
  display: flex;
  padding: 8px 20px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

const Tab = styled.div<{ $active?: boolean }>`
  display: flex;
  height: 36px;
  padding: 0 14px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #e8e9ed;
  background: #fff;
  color: #424854;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.26px;

  ${({ $active }) =>
    $active &&
    `
  background: #272C36;
  color: #F4F5F7;
  border-color: transparent;
`}
`;

const Content = styled.div`
  display: flex;
  height: 100%;
  padding: 8px 20px 24px 20px;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  overflow-y: auto;
`;

const Item = styled.div`
  display: flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
`;

const ItemLabel = styled.div<{ $active?: boolean }>`
  display: flex;
  padding: 8px;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  color: ${({ $active }) => ($active ? '#0c0e12' : '#787D87')};
  font-size: 16px;
  font-weight: 500;
  line-height: 24px; /* 150% */
  letter-spacing: -0.32px;
`;

const DropdownRegion = styled.div`
  display: flex;
  padding: 4px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 8px;
  background: #f4f5f7;
`;

const DropdownArrow = styled.img<{ $open?: boolean }>`
  width: 20px;
  height: 20px;
  transform: ${({ $open }) => ($open ? 'rotate(-90deg)' : 'rotate(90deg)')};
`;

const DropdownRegionLabel = styled.div`
  display: flex;
  padding: 8px;
  align-items: center;
  flex: 1 0 0;
  color: #424854;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px; /* 150% */
  letter-spacing: -0.32px;
`;

const Bottom = styled.div`
  display: flex;
  align-self: stretch;
  padding: 16px 24px 24px 24px;
  align-items: center;
  gap: 8px;
`;

const Button = styled.button`
  border: none;
  outline: none;

  display: flex;
  height: 44px;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;

  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.3px;
`;

const CancleButton = styled(Button)`
  background: #f4f5f7;
  color: #424854;
`;

const ConfirmButton = styled(Button)`
  background: #3f6ef1;
  color: rgba(244, 245, 247, 0.88);
  flex: 1 0 0;
`;
